module.exports = __webpack_public_path__ + "static/media/project2_reward.a717cc27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/project2_reward.jpg
// module id = 359
// module chunks = 0